export const locale = {
  lang: 'pt',
  data: {
    'REQUERIMIENTOS': {
      'BOTONES':{
        'SIGUIENTE': 'Próximo',
        'ANTERIOR': 'Anterior',
        'FINALIZAR': 'Fim',
        'ACEPTAR': 'Aceito os requisitos técnicos '
      },
      'MENSAJES': {
        'CONFREQ': 'Aceitou correctamente os requisitos técnicos da plataforma',
        'OK':'OK',
      },
      'CABECERA':{
        'TITULO': 'Requisitos técnicos',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
      'PASO1':{
        'TITULO': 'Requisitos do parceiro',
        'SUB_TITULO': '1. Requisitos de aplicação',
        'SUB_TITULO2': '2. Requisitos de capacidade do navegador',
        'TABLE_REQUERIMIENTOS' : {
          'TD_SISTEMAS': 'Sistemas operativos:',
          'TD_LABEL_RECOMENDADO': 'ou superior (RECOMENDADADO).',
          'TD_NAVEGADOR': 'Browser: ',
          'TD_LABEL_SUPERIOR': 'ou superior.',
          'TD_LABEL_LASTVERSION': '(Versão mais recente).',
          'TD_LABEL_LASTVERSION_MIN': '(última versão, versão mínima 12.3).'
        },
        'TABLE_REQUISITOS' : {
          'TD_CERTIFICAR': 'Certificado de segurança: ',
          'TD_COOKIES': 'Biscoitos permitidos: ',
          'TD_CIFRADO': 'Encriptação TLS: ',

          'TD_CONTENT1': 'Certifique-se de que o certificado de segurança ou Let\'s Encrypt Authority X3 grantor authority é classificado como digno de confiança pela sua organização.',
          'TD_CONTENT2': 'O navegador deve ter JavaScript 1.2.',
          'TD_CONTENT3': 'Os servidores de plataforma CULTURAL GO® manusear cookies, que não recolhem informações do utilizador ou do seu sistema operativo, mas são necessários para o funcionamento do inquérito e devem ser activados.',
          'TD_CONTENT4': 'Dependendo do tipo de projecto, um dos nossos módulos de relatório requer apenas encriptação TLS.'
        },
        'PARRAFO1': {
          'SUBPARRAFO1': 'Se o cliente pretender utilizar outro sistema operativo, para além dos listados acima, tais como versões do LINUX, UNIX, ChromeOS, Mobile Operating Systems, etc., o cliente é responsável por garantir que o',
          'SUBPARRAFO2': 'Devido à vulnerabilidade de POODLE (CVE-2014-3566) e a cessação do suporte para Windows XP pela Microsoft, Great Place to Work® deixará de suportar o acesso aos nossos sítios Web seguros a partir de computadores com Windows XP. Great Place to Work® manterá navegadores; no entanto, esses navegadores não serão testados ou suportados.'
        },
        'ADVERT': 'NOTA: A partir da versão 5.0 de Cultural Go O suporte do Microsoft Internet Explorer é removido.'
      },
      'PASO2':{
        'TITULO': 'Autenticação do inquérito',
        'SUB_TITULO1': '3. Certificados',
        'SUB_TITULO2': '4. Computador/laptop do contribuidor',
        'SUB_TITULO3': '5. Resposta ao inquérito a partir de dispositivos móveis',
        'SUB_TITULO4': '1. Questões a considerar',
        'SUB_TITULO5': '2. Apoio linguístico',
        'PARRAFO1': 'A plataforma CULTURAL GO® utiliza o certificado SSL Let\'s Encrypt Authority X3 fornecido pelo Internet Security Research Group (ISRG). Caso o certificado não esteja presente, é exibida uma página de aviso de segurança ao utilizador informando-o de que existe um problema com o certificado de segurança do sítio web. O utilizador pode seleccionar continuar a aceder ao website ou exibir mais informações sobre o assunto. Embora o utilizador possa continuar no site, a mensagem de aviso continuará a ser exibida cada vez que o site for acedido.',
        'PARRAFO2':{
          'LINEA1':'Para aceder ao inquérito online, o computador/laptop do colaborador necessita: ',
          'LINEA2':'Acesso total ao endereço web do inquérito (certifique-se de que o utilizador tem as permissões adequadas no caso de ter uma firewall).',
          'LINEA3':'Caso o link do inquérito seja enviado por correio, o utilizador deve ter acesso à sua conta de correio electrónico empresarial.',
        },
        'PARRAFO3': 'O inquérito foi validado em dispositivos móveis, tais como comprimidos e telefones. A apresentação e a disposição dos elementos do inquérito serão ajustados à resolução do ecrã do dispositivo. Depende do modelo do dispositivo para que o inquérito funcione.',

        'PARRAFO4': 'O inquérito foi concebido para ter uma experiência agradável para o utilizador nos ecrãs verticais de dispositivos móveis com resolução Full HD.',

        'PARRAFO5': 'Em muitas organizações, as redes WiFi não dão acesso total à navegação em dispositivos pessoais. Se decidir utilizar o seu dispositivo pessoal e ligar-se através de uma rede WiFi, terá de validar que tem acesso ao sítio Web do inquérito.',

        'PARRAFO6': 'O utilizador deve estar ciente de que se utilizar uma ligação directa à sua empresa de telemóveis, poderão ser aplicadas taxas de navegação.',
        'PARRAFO7':{
          'LINEA1':'Os utilizadores terão acesso ao site através da utilização de um URL específico que é gerado para cada projecto. Os links não contêm qualquer informação do utilizador.',
          'LINEA2':'Deve ser introduzido um código de utilizador único no URL global seguro para permitir o acesso ao inquérito.',
          'LINEA3':'O código único do utilizador será fornecido a cada utilizador ou por correio electrónico, SMS, ou ser-lhe-á fornecido manualmente através do seu Coordenador de Recursos Humanos (ou posição equivalente).',
        },
        'PARRAFO8':{
          'LINEA1':'1. O cliente deve controlar a entrega do convite por e-mail aos seus empregados:',
          'LINEA2':'Se o servidor de correio electrónico for subcontratado, contactar previamente o fornecedor de correio electrónico para o informar dos requisitos.',
          'LINEA3':'Se o servidor de e-mail estiver no local, peça assistência ao seu departamento de TI.',
          'LINEA4':'Nota: Os convites para inquéritos não podem ser enviados a clientes de correio electrónico gratuito tais como: Hotmail, Gmail, Yahoo, etc.',
          'LINEA5':'2. Se o e-mail corporativo do cliente for OUTLOOK WEBACCESS, os funcionários terão de copiar a ligação web e abri-la no navegador da web, caso contrário será gerado um erro.',
          'LINEA6':'3. Deixar o inquérito inactivo no computador ou dispositivo onde o inquérito é realizado durante mais de 30 minutos irá gerar um "TIME OUT", e terá de se registar novamente para o inquérito, com a mesma palavra-passe. O sistema vai levá-lo à pergunta exacta em que se encontrava.',
          'LINEA7':'4. Cada resposta é guardada quando a selecciona. Não poderá seleccionar qualquer outra resposta até que o processo de gravação esteja completo, assegurando assim que o progresso do utilizador na resposta ao inquérito tenha sido gravado.',
        },
        'PARRAFO9':{
          'LINEA1':'O nosso inquérito apenas suporta as línguas configuradas no selector de línguas e só pode ser seleccionado no início do inquérito.',
          'LINEA2':'Se as línguas seleccionadas estiverem em qualquer língua que requeira caracteres especiais, o utilizador deve assegurar-se de que o seu navegador suporta as fontes.',
          'LINEA3':'Geralmente, todos os utilizadores que pretendem ver o inquérito em qualquer língua que exija caracteres especiais já têm pacotes de línguas instalados, pelo que isto pode não ser necessário para todos, excepto para alguns utilizadores.',
          'LINEA4':'Se necessitar da utilização de uma fonte específica para qualquer projecto no site, os utilizadores devem ter essa fonte específica instalada em cada uma das suas respectivas máquinas. Quando necessário, Great Place to Work® comunicará estes requisitos à equipa de projecto do cliente.',
        },
        'PARRAFO10': 'Importante: O utilizador deve certificar-se de que o navegador não tem a função de tradução automática activada, caso contrário o selector de línguas pode não funcionar.',
      },
      'PASO3':{
        'TITULO': 'Requisitos de ligação à Internet',
        'SUB_TITULO1': '1. Requisitos de encriptação SSL',
        'SUB_TITULO2': '2. Requisitos de largura de banda',
        'SUB_TITULO3': '3. Listas brancas de Firewall: IP do servidor Web e acesso ao domínio',
        'SUB_TITULO4': '4. Listas brancas de Firewall: servidor de e-mail',
        'SUB_TITULO5': '5. Geração de grupos de resposta (quiosques)',
        'PARRAFO1': 'O navegador da web do cliente deve suportar sites habilitados para SSL. Isto permite ao utilizador a máxima privacidade da informação personalizada.',

        'PARRAFO2': 'A largura de banda depende do tipo de inquérito e relatórios implementados e dos componentes (vídeo e imagens) utilizados. Para inquéritos com estes componentes, a ligação recomendada é de 1+ Mbit/s por utilizador. A usabilidade será afectada se for utilizada uma ligação inferior. Para inquéritos com nenhum destes componentes, é necessária uma ligação normal à Internet.',

        'PARRAFO3':{
          'LINEA1':'Os seguintes pontos devem constar do inquérito e dos relatórios de sítios a trabalhar CULTURAL GO®: whitelists',
          'LINEA2':'É importante conceder as permissões necessárias aos seguintes domínios e endereços IP para que os seus empregados possam ter acesso ao inquérito Great Place to Work Trust Index®.',
        },
        'PARRAFO31': 'Importante: Os utilizadores devem ter acesso total e ilimitado (sem restrições) a todo o domínio.',
        'PARRAFO4':{
          'LINEA1':'O servidor de correio requer acesso total aos seguintes endereços de correio electrónico:',
          'LINEA2':'As seguintes permissões são necessárias no seu servidor de correio electrónico para evitar que as mensagens de correio electrónico Great Place to Work® sejam classificadas como spam:',
        },
        'PARRAFO5':{
          'LINEA1':'Importante:',
          'LINEA2':'Esta configuração destina-se a evitar que o endereço de correio electrónico seja detectado como spam.',
          'LINEA3':'O servidor de correio deve ser capaz de receber milhares de e-mails da mesma conta.',
          'LINEA4':'Nas regras de segurança do seu fornecedor de correio electrónico, adicione os domínios e, se possível, adicione as listas brancas como contas de correio electrónico de contacto.',
        },
        'PARRAFO6': 'Em muitas organizações é comum colocar vários computadores para que os utilizadores possam ir ter com eles para responder ao inquérito. É necessário que sejam feitos testes de largura de banda suficiente nos pontos de venda da Internet para assegurar que os dispositivos de ligação suportam todo o tráfego gerado pela resposta do grupo.',
        'PARRAFO7': 'Recomenda-se que antes de os utilizadores começarem a responder em grupo, um especialista em TI verifique se não existem problemas de ligação à Internet.',
        'TABLA1':{
          'TD_ELEMENTO':'Item',
          'TD_REGION1':'Região do México',
          'TD_REGION2':'Região da América Central e do Sul',
          'TD_REGION3':'Região da Ásia',
          'TD_REGION4':'Região Europa',
          'TD_DOMINIO':'Domínio',
          'TD_SUBDOMINIO':'Subdomínio',
          'TD_DIRECCION':'Endereço IP',
          'TD_PUERTOS':'Portos',

        },
        'TABLA2':{
          'TD1':'Conta de e-mail do remetente:',
          'TD2':'Domínio'
        },
        'TABLADOMINIO':{
          'TD_ELEMENTO01':'Aplicativo ',
          'TD_ELEMENTO02':'Hospedagem',
          'TD_ELEMENTO03':'IP',
          'TD_ELEMENTO04':'Porta',
          'TD_ELEMENTO05':'Subdomínio',
        },
        'TITLE1':'Domínio: CulturalGo.com',
        'TITLE2':'Domínio: gptw.global',
      },
      'PASO4':{
        'TITULO': 'Níveis de serviço',
        'SUB_TITULO1': '1. Apoio',
        'SUB_TITULO2': '2. Disponibilidade do sistema',
        'SUB_TITULO3': '3. Força maior',
        'SUB_TITULO4': '4. Concorrência',
        'SUB_TITULO5': '5. Janela de manutenção',
        'TABLA1':{
          'TD_REGION1':'Região do México',
          'TD_REGION2':'Região da América Central e do Sul',
          'TD_REGION3':'Região da Ásia',
          'TD_REGION4':'Região Europa'
        },
        'PARRAFO1':{
          'LINEA1':'Disponibilidade da aplicação = 99.5%',
          'LINEA2':'Para assegurar a disponibilidade do sistema, a aplicação é monitorizada 24 horas por dia, 7 dias por semana e 365 dias por ano com um sistema de alerta e procedimentos de apoio.',
        },
        'PARRAFO2': 'Força maior significa eventos para além do controlo razoável de um partido, incluindo, mas não se limitando a, guerra, greves, regulamentação governamental, agitação civil ou actos de terrorismo ou terramotos, que tornam legalmente impraticável, ilegal ou impossível para tais partidos o desempenho das suas funções.',
        'PARRAFO3': 'O nível de serviço de disponibilidade do sistema não cobre qualquer falta de serviço causada pelo não cumprimento pelos clientes dos requisitos técnicos estabelecidos neste documento, ou qualquer evento classificado como Força Maior.',
        'PARRAFO4': 'O ambiente de recolha de dados pode suportar 10.000 utilizadores simultâneos ou completar até 1,5 milhões de inquéritos num período de 24 horas. A aplicação de relatórios pode suportar 500 utilizadores simultâneos ou até 1.000 sessões num período de 24 horas.',
        'PARRAFO5':{
          'LINEA1':'Great Place to Work® reserva-se o direito de interromper o pedido de inquéritos e relatórios para manutenção programada. Os horários de manutenção programada serão comunicados com antecedência a todas as partes afectadas.',
          'LINEA2':'Durante a janela de manutenção acima mencionada, a aplicação pode não estar disponível para os utilizadores. Se Great Place to Work® necessitar de uma janela de manutenção prolongada para actividades adicionais, o contacto do cliente designado será notificado.',
          'LINEA3':'Para manutenção de emergência, a janela de manutenção pode não ser anunciada. Para os clientes afectados por manutenção de emergência, o contacto designado do cliente será notificado.'
        },
      },
      'PASO5':{
        'TITULO': 'Política de Privacidade de Dados',
        'SUB_TITULO1': '1. Política',
        'PARRAFO1': 'A informação que é enviada e armazenada nos servidores da Plataforma CULTURAL GO® é protegida e salvaguardada ao abrigo de políticas e procedimentos que cumprem a norma ISO 27001. Qualquer dúvida que tenha sobre isto, por favor consulte o seu Great Place To Work®.',
      },
      'VALIDACION':{
        'TITULO': 'Validação dos requisitos técnicos',
        'DATOSTI':{
          'INFOEMPRESA': 'Informação sobre a empresa',
          'NOMBREEMPRESA': 'Nome da empresa',
          'NOMBRE': 'Nome do gestor de TI',
          'EMAIL': 'Endereço de correio electrónico',
          'TEL': 'Telefone',
          'EXT': 'Extensão',
          'CEL': 'Telemóvel',
          'TOOLTIP': 'Ver informação sobre a empresa'
        },
        'TIMELINE':{
          'TITULO': 'Processo de validação dos requisitos técnicos',
          'CARGANDO': 'Carregar a informação',
          'PROGRESO': 'Progresso actual: ',
          'PROGRESO2': 'Progresso da validação dos requisitos: ',
          'STATUS': {
            'OK': 'Estado: Concluído',
            'NOTOK': 'Estado: Não completado',
            'TOOLTIP': 'Marcar como concluído'
          },
          'COMENTARIO': {
            'TITULO_1': 'Guardar um comentário sobre este passo',
            'INPUT': 'Escreva o seu comentário',
            'ENVIAR': 'Enviar comentário',
            'TITULO_2': 'Comentários (mais antigo primeiro)',
            'CANNOT': 'Nenhum comentário pode ser enviado uma vez concluída a etapa',
          },
          'NOMBRES': {
            '1': 'Envio de correio para o gestor de TI',
            '2': 'Configuração RT - Telefonar ao cliente',
            '3': 'Configuração RT - Testes',
            '4': 'Envio do questionário',
            '5': 'Fim do questionário'
          }
        },
        'MENSAJES': {
          'NADA': 'Não escreveu o comentário, não pode guardar um comentário vazio',
          'AUNNO': 'Ainda não pode executar esta etapa, a validação dos requisitos técnicos deve ser concluída em primeiro lugar',
          'COMPLETAR': 'Confirma alterar o estado desta etapa para "Concluído"?',
          'COMPLETAR_OK': 'Este passo foi alterado para "Completado" correctamente',
          'BOTONES': {
            'SI': 'Sim',
            'NO': 'Não'
          },
          'NOCOMPLETAR': 'Ainda não pode marcar este passo como completo\n\nDeve completar primeiro o passo anterior'
        }
      }
    },
    'REQUERIMIENTOSV3':{
      'MENSAJES':{
        'MENSAJE_SUCCESS_OK':'Requisitos técnicos atualizados',
        'MENSAJE_CONEX_OK':'Conexão bem sucedida',
        'ACTUALIZANDO_REQUERIMIENTOS': 'Atualização de requisitos técnicos',
        'MENSAJE_RESPUESTA_REQ':'* Resposta exigida',
        'WAR_ING_CORR ':' Digite pelo menos um e-mail ',
      },
      'CABECERA':{
        'TITULO': 'Requerimientos técnicos',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
       'BOTONES':{
              'SIGUIENTE': 'Próximo',
              'ANTERIOR': 'Anterior',
              'FINALIZAR': 'Terminar',
              'ACEPTAR': 'Eu aceito os requisitos técnicos '
            },
        'PASO1':{
          'TITULO':'Requisitos de contribuidor',
          'SUB_TITULO':'Requerimientos Técnicos',
          'SUB_TITULO2':'Plataforma CulturalGo® 5.0',
          'TEXTO0_PARTE_1':'O objetivo deste documento é informar sobre os requisitos técnicos da plataforma CulturalGo® para garantir um acesso fácil e eficaz ao sistema de pesquisa Greate Place to Work®, Trust Index © e assim evitar problemas técnicos recorrentes.',
          'TEXTO0_PARTE_2':'É imprescindível cumprir e verificar cada um dos requisitos técnicos para que os colaboradores de sua organização recebam e respondam a pesquisa. Caso contrário, é muito provável que ocorram complicações como bloqueios e / ou interfaces que fazem com que o colaborador não consiga receber e responder a pesquisa.',
          'SUB_TITULO3':'Requisitos de Contribuidor (Usuário Final)',
          'SUB_TITULO4':'Requisitos de aplicação',

          'SUB_TITULO2_CARCA':'Plataforma CulturalGo® 5.0',
          'TEXTO0_PARTE_1_CARCA':'O objetivo deste documento é informar sobre os requisitos técnicos da plataforma CulturalGo® para garantir um acesso fácil e eficaz ao sistema de pesquisa Greate Place to Work®, Trust Index © e assim evitar problemas técnicos recorrentes.',
          'TEXTO0_PARTE_2_CARCA':'É imprescindível cumprir e verificar cada um dos requisitos técnicos para que os colaboradores de sua organização recebam e respondam a pesquisa. Caso contrário, é muito provável que ocorram complicações como bloqueios e / ou interfaces que fazem com que o colaborador não consiga receber e responder a pesquisa.',
          'TEXTO0_PARTE_1_INNMO':'O objetivo deste documento é informar sobre os requisitos técnicos da plataforma CulturalGo® para garantir um acesso fácil e eficaz ao sistema de pesquisa Innmotion, Trust Index © e assim evitar problemas técnicos recorrentes.',

          'TABLE_REQUERIMIENTOS' : {
            'TD_SISTEMAS': 'Sistemas operacionais:',
            'TD_LABEL_RECOMENDADO': 'ou superior (RECOMENDADO)..',
            'TD_NAVEGADOR': 'Navegador: ',
            'TD_LABEL_SUPERIOR': 'ou mais alto..',
            'TD_LABEL_LASTVERSION': '(última versão).',
            'TD_LABEL_LASTVERSION_MIN': '(versão mais recente, versão mínima 12.3).'
          },
          'TEXTO1_PARTE_1':'Se o cliente pretende usar outro sistema operacional diferente dos listados acima, como versões do LINUX, UNIX, Chrome OS, sistemas operacionais móveis, etc., o cliente é responsável por garantir que a pesquisa seja executada corretamente em seu software de navegador.',
          'TEXTO1_PARTE_2':'Devido à vulnerabilidade do POODLE (CVE-2014-3566) e ao encerramento do suporte do Windows XP pela Microsoft, o Great Place to Work® não oferecerá mais suporte ao acesso aos nossos sites seguros a partir de computadores que executam o Windows XP. O Great Place to Work® manterá suporte para computadores que executam o Windows XP usando versões dos navegadores Chrome ou Firefox listados nos requisitos do aplicativo. O acesso ainda pode estar disponível em outros navegadores; no entanto, esses navegadores não serão testados ou suportados.',
          'TEXTO1_PARTE_2_INNO':'Devido à vulnerabilidade do POODLE (CVE-2014-3566) e ao encerramento do suporte do Windows XP pela Microsoft, o Innmotion não oferecerá mais suporte ao acesso aos nossos sites seguros a partir de computadores que executam o Windows XP. O Innmotion manterá suporte para computadores que executam o Windows XP usando versões dos navegadores Chrome ou Firefox listados nos requisitos do aplicativo. O acesso ainda pode estar disponível em outros navegadores; no entanto, esses navegadores não serão testados ou suportados.',
          'TEXTO2_PARTE_1':'Nota: A partir da versão 5.0 CuturalGo®, o suporte para Microsoft Internet Explorer será removido',
        },
        'PASO2':{
          'TITULO': 'Autenticação de pesquisa',
          'SUB_TITULO1': 'IP do servidor web e acesso ao domínio',
          'SUB_TITULO2': ' Firewall Whitelists:',
          'TEXTO0_PARTE_1': 'O seguinte deve aparecer nas listas de permissões para que sites de pesquisas e relatórios funcionem em La Plataforma CulturalGo®:',
          'TEXTO1_PARTE_1': 'É importante conceder as permissões necessárias aos seguintes domínios e endereços IP para permitir que seus funcionários acessem a pesquisa Great Place to Work® Trust Index ©',
          'TEXTO1_PARTE_1_INNMO': 'É importante conceder as permissões necessárias aos seguintes domínios e endereços IP para permitir que seus funcionários acessem a pesquisa Innmotion Trust Index ©',
          'BTN_COMPRO_CONEX':'Verificar conexão',
          'BTN_SUCCE_CONEX':'Conexão estabelecida',
          'TOOL_BTN_COMPRO_CONEX':'Serviço em construção',
          'MODAL_SUCCESS_CONEX':'A conexão foi bem sucedida',
          'ETI_INTRUC_DOMA_COPY': 'Copie e envie este link caso precise verificar conexões a partir de qualquer ponto de acesso descentralizado (Não afeta a validação dos Requisitos Técnicos)',
          'BTN_INTRUC_ENLA': 'Copie o link',
          'MODAL_ENLA_SUCC': 'Link foi copiado',

          'SUB_TITULO2_CARCA': 'Firewall whilelists:',
          'TEXTO0_PARTE_1_CARCA': 'O seguinte deve aparecer nas listas de permissões para que sites de pesquisas e relatórios funcionem em La Plataforma CulturalGo®:',
          'TEXTO1_PARTE_1_CARCA': 'É importante conceder as permissões necessárias aos seguintes domínios e endereços IP para permitir que seus funcionários acessem a pesquisa Great Place to Work® Trust Index ©',

          'TABLE_CONTEN':{
           'TH_ELEMENTO':'Elemento',
           'TH_REGIONM':'Região Global',
           'TH_REGIONC':'Região da América Central e do Sul',
           'TH_REGIONA':'Região da Ásia',
           'TH_REGIONE':'Região Europa',
           'TH_DOMINIO_PRINCIPAL':'Domínio Principal',
           'TH_APLICADOR':'Aplicador de pesquisa',
           'TH_PLATAFORMA':'Plataforma de Administração',
           'TH_ENVOLTURA':'Url Wrap',
           'TH_RESULTADOS':'Resultados (Tableau®)',
           'TH_CULTURE':'Culture Audit®',
           'TH_PORTAL':'Portal de contagem externa',
           'TH_SUBDOMINIO':'Subdomínio',
           'TH_DIRECCION_IP':'Endereço de IP',
           'TH_PUERTOS':'Ports',
           'TH_DOMINIO':'Domínio',
           'TEXTO1':'• Todos os links para as pesquisas serão entregues através do URL wrapper 4all.gptw.global/, que contém um redirecionamento para o site final da pesquisa atribuída a cada empresa.',
           'TEXTO2':'• Por motivos de segurança, os algoritmos da CulturalGo® podem alterar a URL da pesquisa final a qualquer momento durante o período da pesquisa. Portanto, o wrapper 4all.gptw.global/ deve sempre ser usado, que é permanente durante todo o levantamento. ',
           'TEXTO3':' IMPORTANTE:',
           'TEXTO4':' O link da pesquisa nunca deve ser acessado diretamente (por exemplo, http://newsurvey.culturalgo.com/Ax013s203ls), pois o token que compõe a pesquisa pode mudar de tempos em tempos sem aviso prévio',
           'TEXTO5':' Importante:',
           'TEXTO6':' Os usuários devem ter acesso total e ilimitado (irrestrito) a todo o domínio.',
           'TEXTO7':' servidor de e-mail',
           'TEXTO8':' O servidor de e-mail requer acesso total aos seguintes endereços de e-mail:',
           'TEXTO9':' As seguintes permissões são necessárias em seu servidor de e-mail para evitar que e-mails do Great Place to Work® sejam enviados para clasi ﬁ quen como SPAM:',
           'TEXTO9_INNMO':' As seguintes permissões são necessárias em seu servidor de e-mail para evitar que e-mails do Innmotion sejam enviados para clasi ﬁ quen como SPAM:',
           'TABLA_CONTENT2':{
             'TD_CUENTA_CORREO':' Conta de e-mail do remetente:',
             'TD_DOMINIO':' Domínio:',
             'TD_IP_ADDRE_PRIM':'Endereço IP primário:',
             'TD_SECON_IP':'Endereços IP secundários:',
             'TD_SUBDOMINIO':'Subdomínios para redireccionamento de ligações (são utilizados para monitorização):',
           },
           'TEXTO10':'•	Esta configuração evita que o endereço de e-mail seja detectado como spam',
           'TEXTO11':'•	O servidor de email deve ser capaz de receber milhares de emails da mesma conta',
           'TEXTO12':'•	Nas regras de segurança do seu provedor de e-mail, adicione os domínios para a lista de permissões e, se possível, adicione-os como contas de e-mail de contato',
           'TEXTO13':'Se você precisar de suporte, envie uma mensagem para',
           'BTN_CONFIGURACION':'Domínios e IPs foram configurados',
           'BTN_ACCESO_ENCUESTA':'Fiz os testes e não tive complicações',
           'BTN_RECIBI_CORREOS':'Eu recebi os e-mails na minha caixa de entrada',

          }
        },
        'PASO3':{
          'TITULO':'Nesta seção você poderá fazer um teste de recepção do correio',
          'TIT_TES_PRU_ACC_SURV': 'Nesta seção você poderá realizar um teste de visualização de uma pesquisa genérica (não relacionada à de sua organização):',
          'INS2_TES_PRU_ACC_SURV ':' 1. Clique em:',
           'INS1_1_TES_PRU_ACC_SURV':'Copiar chave:',
           'INS1_TES_PRU_ACC_SURV ':' 2. Acesse o seguinte link: ',
           'INS3_TES_PRU_ACC_SURV ':' 3. Cole a chave na célula de senha ',
           'INS4_TES_PRU_ACC_SURV ':' 4. Clique em login ',
           'CONTAC':'Em caso de erros técnicos, entre em contato conosco pelo e-mail support@itbm.mx e teremos o maior prazer em resolvê-lo.',
           'WARN_TEST_EMAIL':'Para continuar com o processo, enviamos-lhe um link de confirmação para seu endereço de e-mail.',
           'MSJ_SUCC_EMA_': 'Os emails foram enviados com sucesso',
           'MODAL_WARNI_BAND':'Para continuar o processo, confirmar o acesso à pesquisa e/ou o recebimento do e-mail',
           'MSJ_COP_CLA': 'Copiar a chave do utilizador',
           'MODAL_VERIFI_INFO':'Verificação de informações',

           'MODAL_WARNI_EMAL':'IMPORTANT: This link should not be shared with the employees of the organization, because it is a test link in order to validate that the necessary permissions have been granted at the opening of the survey.',
           'CONTAC_CARCA':'Em caso de erros técnicos, entre em contato conosco pelo e-mail soporte_ca@gptwonline.com e teremos o maior prazer em resolvê-lo.',
           'WARN_TEST_EMAIL_CARCA':'Para continuar com o processo, enviamos-lhe um link de confirmação para seu endereço de e-mail.',
         },
        'PASO4':{
          'TITULO':'Questionário de Validação',
          'PREGUNTAS':{
            'PREGUNTA_1':'1.-¿Eu faço as configurações sem problemas?',
            'PREGUNTA_1_INDI':'(Se você teve algum problema, especifique)',
            'PREGUNTA_2':'2.-Seu servidor de e-mail era confiável por::',
            'PREGUNTA_2_INDI1':'a) Sua equipe interna de TI (tem controle total das configurações).',
            'PREGUNTA_2_INDI2':'b) Eu solicito um tíquete do seu provedor (mencione o nome do provedor).',
            'PREGUNTA_3':'3.-¿Seus e-mails estão em contas comerciais (Gmail, Microsoft, Yahoo !, etc.)?',
            'PREGUNTA_4':'4.-¿Você registrou o domínio gptwonline.com, lembre-se de que os e-mails que você recebe são deste domínio, certifique-se de que eles não vão para spam ou lixo eletrônico?',
            'PREGUNTA_5':'5.-¿Você tem uma maneira de obter uma lista de e-mails recebidos (registro de e-mail)?',
            'PREGUNTA_6':'6.-¿Quais navegadores de internet seus colaboradores instalaram? (Liste; Navegador - versão)',
            'PREGUNTA_7':'7.-¿Você concedeu as permissões necessárias para que seus funcionários navegassem na pesquisa? (Se eu apresentar um problema, especifique)',
            'PREGUNTA_8':'8.-¿Para a aplicação de sua pesquisa, você tem salas de informática planejadas para que seus funcionários respondam a sua pesquisa?',
            'PREGUNTA_8_INDI1':'(¿Em caso afirmativo, indique o número de salas e o número de equipamentos por sala?)',
          },
          'BTN_VALIDAR_ENVIAR':'Validar e enviar',
        },
        'PASO5':{
          'TITULO': 'Política de Privacidade de Dados',
          'SUB_TITULO':'Política de Privacidade de Dados',
          'PARRAFO1': 'As informações enviadas e armazenadas nos servidores da Plataforma CULTURAL GO® são protegidas e salvaguardadas por políticas e procedimentos que atendem à ISO 27001. Se você tiver alguma dúvida sobre isso, entre em contato com seu consultor Great Place To Work®.',
          'PARRAFO1_INNMO': 'As informações enviadas e armazenadas nos servidores da Plataforma CULTURAL GO® são protegidas e salvaguardadas por políticas e procedimentos que atendem à ISO 27001. Se você tiver alguma dúvida sobre isso, entre em contato com seu consultor Innmotion.',
          'PARRAFO2':'Marcas Registradas',
          'PARRAFO3_1':'•	Great Place to Work® e Trust Index ©',
          'PARRAFO3_2':'são marcas registradas do Great Place To Work Institute USA, neste documento essas marcas são usadas apenas como referência.',
          'PARRAFO3_1_INNMO':'•	Innmotion e Trust Index ©',
          'PARRAFO3_2_INNMO':'são marcas registradas do Innmotion Institute USA, neste documento essas marcas são usadas apenas como referência.',
          'PARRAFO4_1':'•	Cultural Go®, SuccessGo® ',
          // 'PARRAFO4_2':'É uma marca registrada da Innovación Tecnológica B&M S.A. de C.V. México',
          'PARRAFO4_2':' e, em geral, toda a plataforma Go!® são marcas registadas do criador.',
          'PARRAFO5':'Obrigado!!',
          'BTN_FINALIZAR':'Concluir e enviar',
          'BTN_FINA_REQUE ':' Requisitos técnicos concluídos ',


        },
        'COPY_MESSAGE':'Chave copiada para a área de transferência',
        'COMPR_CONEXI':'Verificação da conexão',
        'SUCCES_CONF_EMA':{
        'MODAL_SUCCESS':'A recepção do correio foi validada',
        'MODAL_INSTRUCCI':'Favor fechar a aba',
        },
        'FORMULARIO_TI': {
          'TAB': 'Fim do processo',
          'TITULO': 'Detalhes do revisor',
          'SUBTITULO': 'Para concluir o processo, insira seus dados no formulário a seguir e clique no botão Concluir',
          'DONE': 'O processo já terminou',
          'FINALIZAR': 'Finalizar requisitos técnicos',
          'NOTYET': 'O gerente de TI não concluiu o processo, ele poderá confirmar os requisitos técnicos até que o gerente de TI insira seus dados',
          'FORM': {
            'NOMBRE': 'Nome',
            'MAIL': 'O email',
            'FECHA': 'Data de término',
            'SINENVIAR': 'Dados ainda não enviados'
          },
          'MENSAJES': {
            'NOMBRE': 'Você não inseriu seu nome no campo indicado',
            'GUARDANDO': 'As informações que você inseriu estão sendo salvas, por favor, aguarde um momento',
            'GUARDADO': 'Os dados foram salvos corretamente'
          }
        },
          'ETI_EMPRE':'Empresa',
          'CONTAC': 'Contacte-nos:',
        'CONTAC_DES': 'Como podemos ajudá-lo?',
        'SEND_EMA':'Enviar uma mensagem',
        'LABEL': 'Descrição',
        'TEX_BTN_SEND': 'Enviar',
        'MODA_SEN_EMAI':'Envio de mensagem...',
        'SUCC_MODA_SEN_EMAI': 'A mensagem foi enviada com sucesso',

    }
  }
};
